import { gql } from 'apollo-boost';

export const CREATE_AGREEMENT = gql`
mutation createAgreement($input: CreateAgreementInput!) {
    Result:createAgreement(input: $input) {
      id
    }
  }
`;

/*
CreateAgreementInput: {
    agreeToTerm,
    personId,
    termId
}
*/